<script lang="ts">
  import LoadingPlaceholder from "../generic/LoadingPlaceholder.svelte";
</script>

<h1 class="sr-only" aria-live="assertive"><slot></slot></h1>
<main>
  <div class="flex flex-row items-center space-x-8" aria-hidden="true">
    <span class="h-20 w-20 overflow-hidden rounded-full">
      <LoadingPlaceholder />
    </span>
    <span class="h-8 flex-1">
      <LoadingPlaceholder />
    </span>
  </div>
</main>
